import { combineReducers } from 'redux';

import byId from './byId';
import error from './error';
import fieldIds from './fieldIds';
import ids from './ids';
import messages from './messages';
import signingProgressType from './signingProgressType';

const participantsReducer = combineReducers({
  byId,
  error,
  fieldIds,
  ids,
  messages,
  signingProgressType,
});

export default participantsReducer;
